const alertContainer = document.querySelector('.block-alert-top');
import getRemBase from 'propel/getRemBase';

//Add height to body for other fixed/absolute elements
if (alertContainer) {
	const alertObserver = new ResizeObserver((entries) => {
		entries.forEach(() => {
			const alertContainerTop = alertContainer.offsetTop;
			const alertContainerHeight = alertContainer.offsetHeight;

			document.body.style.setProperty(
				'--alert-height',
				`${(alertContainerHeight + alertContainerTop) / getRemBase()}rem`
			);
		});
	});

	alertObserver.observe(alertContainer);
}

// Clone alert-top menu items into hamburger navigation menu
const alertMenu = document.querySelector('.block-alert-top__menu');

if (alertMenu) {
	const navMenu = document.querySelector('.block-navigation__menu');

	if (navMenu) {
		let mobileAlertMenu = null;

		window.addEventListener('navigation-opened', () => {
			if (mobileAlertMenu) {
				return;
			}

			mobileAlertMenu = document.createElement('div');
			mobileAlertMenu.className = 'block-alert-top__mobile-menu';

			const links = alertMenu.querySelectorAll(
				'.block-alert-top__menu-link'
			);

			links.forEach((link) => {
				const clone = link.cloneNode(true);
				mobileAlertMenu.appendChild(clone);
			});

			navMenu.appendChild(mobileAlertMenu);
		});

		window.addEventListener('navigation-closed', () => {
			if (mobileAlertMenu) {
				mobileAlertMenu.remove();
				mobileAlertMenu = null;
			}
		});
	}
}
